export enum SweetFaceTransactionType {
  CARD = 'card',
  REFUND = 'refund',
  GIFT_CARD = 'giftcard',
  CASH = 'cash',
}